//     This code was generated by a Reinforced.Typings tool. 
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { IApiRequest } from '../../IApiRequest';

export class AssignManagerRoleRequest extends IApiRequest<void>
{
	public $type = 'AssignManagerRoleRequest';
	constructor(public data: { userId: string, companyId: string }) { super(); }
}
